<template>
  <div class="shop-record">
    <div class="filter-container">
      <el-form :form="info" :inline="true">
        <el-form-item label="">
          <el-input
            v-model.trim="info.name"
            placeholder="搜索企业名称/登录用户名"
            size="small"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="info.provinceName"
            placeholder="请选择省"
            style="width: 126px"
            size="small"
            clearable
            @change="selectedHandle"
          >
            <el-option
              v-for="(item, index) in provinceData"
              :key="index"
              :label="item.rname"
              :value="item.id"
            />
          </el-select>
          <el-select
            v-model="info.cityName"
            placeholder="请选择市"
            style="margin-left: 12px; width: 126px"
            size="small"
            clearable
            @change="selectedHandleCity"
          >
            <el-option
              v-for="(item, index) in cityData"
              :key="index"
              :label="item.rname"
              :value="item.id"
            />
          </el-select>
          <el-select
            v-model="info.areaName"
            placeholder="请选择区"
            style="margin-left: 11px; width: 126px"
            size="small"
            @change="selectedHandleArea"
            clearable
          >
            <el-option
              v-for="(item, index) in areaData"
              :key="index"
              :label="item.rname"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="handleReset">重 置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSearch"
            >搜 索</el-button
          >
        </el-form-item>
        <!-- 新增按钮 -->
        <el-form-item>
          <el-button size="small" type="primary" @click="handleAdd"
            >新 增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="table-container">
      <MyTable
        :page="page"
        v-loading="loading"
        :table-data="tableData"
        :table-option.sync="tableOption"
        @page-change="getList"
        :expand="false"
        :index="false"
        :showpage="true"
      >
        <template slot="state" slot-scope="scope">
          {{ scope.row.state === 0 ? "关闭" : "正常" }}
        </template>
        <template slot="operation" slot-scope="scope">
          <el-button
            type="text"
            @click="handleOpen(scope.row)"
            v-if="scope.row.state === 0"
            style="color: #f5222d"
            >开启</el-button
          >
          <el-button
            type="text"
            @click="handleClose(scope.row)"
            style="color: #262626"
            v-else
            >关闭</el-button
          >
        </template>
      </MyTable>
    </div>
    <ShopAddDialog
      ref="ShopAddDialogRef"
      @submit="handleSubmit"
    ></ShopAddDialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import ShopAddDialog from "./componnet/ShopAddDialog";
import { getProvince, getCity, getArea } from "@/api/shopmange/index";
import { regionAreaTree } from "@/api/saleRule/saleF";
import {
  getShopWhiteListByPage,
  shopWhiteListOperation,
  addShopWhiteList,
} from "@/api/saleRule/agent";
export default {
  name: "ShopRecord",
  components: {
    MyTable,
    ShopAddDialog,
  },
  data() {
    return {
      loading: false,
      info: {
        shopName: "",
        shopAddress: "",
        province: "",
        provinceName: "",
        city: "",
        cityName: "",
        area: "",
        areaName: "",
      },
      provinceData: [],
      cityData: [],
      areaData: [],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "企业名称", prop: "shopName" },
        { label: "登录用户名", prop: "userName" },
        { label: "企业类型", prop: "shopType" },
        { label: "详细地址", prop: "shopAddress" },
        { label: "备案状态", prop: "state", slot: true },
        { label: "更新人", prop: "updateBy" },
        { label: "更新时间", prop: "updateTime" },
        { label: "操作", prop: "operation", slot: true },
      ],
    };
  },
  created() {
    this.getList();
    this.getRegionAreaTree();
  },
  methods: {
    getList() {
      const obj = {
        current: this.page.current,
        size: this.page.size,
      };
      if (this.info.name) {
        obj.name = this.info.name;
      }
      if (this.info.province) {
        obj.province = this.info.province;
      }
      if (this.info.city) {
        obj.city = this.info.city;
      }
      if (this.info.area) {
        obj.area = this.info.area;
      }
      getShopWhiteListByPage(obj).then((res) => {
        this.page.total = res.total;
        this.tableData = res.records;
      });
    },
    handleOpen(row) {
      this.$confirm(`是否确定将“${row.shopName}”的贴敷采购权限开启？`).then(
        () => {
          this.handleRequest(row, 1);
        }
      );
    },
    handleClose(row) {
      this.$confirm(`是否确定将“${row.shopName}”的贴敷采购权限关闭？`).then(
        () => {
          this.handleRequest(row, 0);
        }
      );
    },
    handleRequest(row, state) {
      const obj = {
        id: row.id,
        state: state,
      };
      this.loading = true;
      shopWhiteListOperation(obj)
        .then((res) => {
          this.$message.success("操作成功");
          this.getList();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAdd() {
      this.$refs.ShopAddDialogRef.publicOpen();
    },
    handleSubmit(e) {
      if (!e || !e.shopId) {
        return;
      }
      addShopWhiteList(e).then((res) => {
        this.$message.success("新增成功");
        this.getList();
      });
    },
    handleReset() {
      this.info = {
        shopName: "",
        shopAddress: "",
        province: "",
        provinceName: "",
        city: "",
        cityName: "",
        area: "",
        areaName: "",
      };
      this.cityData = [];
      this.areaData = [];
      this.page.current = 1;
      this.getList();
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    // 获取省市区列表
    getRegionAreaTree(leve) {
      let data = {
        level: 3,
      };
      regionAreaTree(data).then((res) => {
        if (res.code === 0) {
          this.provinceData = res.data;
          if (this.info.province) {
            this.getCityBtn(this.info.province);
          }
          if (this.info.city) {
            this.getAreaBtn(this.info.city);
          }
        }
      });
    },
    selectedHandle(val) {
      this.info.cityName = "";
      this.info.areaName = "";
      this.info.province = val + "";
      if (!val) {
        return;
      }
      this.provinceData.forEach((item) => {
        if (item.id == val) {
          this.info.provinceName = item.rname;
        }
      });
      this.getCityBtn(val);
    },
    getCityBtn(val) {
      getCity({
        id: val,
      }).then((res) => {
        if (res.code == 0) {
          this.cityData = res.data;
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //城市的选择按钮
    selectedHandleCity(val) {
      console.log(val);
      this.info.city = val + "";
      this.cityData.forEach((item) => {
        if (item.id == val) {
          this.info.cityName = item.rname;
        }
      });
      this.info.areaName = "";
      this.getAreaBtn(val);
    },
    getAreaBtn(val) {
      getArea({
        id: val,
      }).then((res) => {
        if (res.code == 0) {
          this.areaData = res.data;
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //地区的选择按钮
    selectedHandleArea(val) {
      this.info.area = val + "";
      this.areaData.forEach((item) => {
        if (item.id == val) {
          this.info.areaName = item.rname;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.shop-record {
  background-color: #ffffff;
  height: calc(100vh - 140px);
  padding: 15px;
  .filter-container {
    ::v-deep .el-form--inline .el-form-item {
      margin-bottom: 0px !important;
    }
  }
  .table-container {
    height: calc(100% - 95px);
  }
}
</style>
